<template>
  <header :class="$style.header">
    <h2 :class="$style.title"><slot /></h2>
    <div :class="$style.header__buttonWrapper">
      <FlatButton
        v-if="showCreate"
        variant="base"
        size="small"
        @click="emit('create')"
      >
        <template #icon>
          <IconPlus />
        </template>
        新規作成
      </FlatButton>
    </div>
    <ButtonClose
      :class="[$style.header__close, $style.close]"
      @click="emit('close')"
    />
  </header>
</template>

<script setup lang="ts">
import IconPlus from '@/components/icons/IconPlus.vue'
import ButtonClose from '@/components/atoms/ButtonClose.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

withDefaults(
  defineProps<{
    showCreate?: boolean
  }>(),
  { showCreate: false }
)

const emit = defineEmits<{
  (event: 'create'): void
  (event: 'close'): void
}>()
</script>

<style lang="scss" module>
.header {
  padding: 24px;
  display: flex;
  align-items: center;

  &__buttonWrapper {
    flex: 1;

    &:nth-child(n + 2) {
      margin-left: 24px;
    }
  }
}

.close {
  padding: 6px;
}
</style>
